import { render, staticRenderFns } from "./DataDetails.html?vue&type=template&id=ad6c37e6&"
import script from "./DataDetails.vue?vue&type=script&lang=js&"
export * from "./DataDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataDetails.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports